var sleep = duration => new Promise(resolve => setTimeout(resolve, duration));

export const nonBlockingPoll = (promiseFn, duration) => promiseFn().then(sleep(duration).then(() => nonBlockingPoll(promiseFn, duration)));
